<div class="modal-header pb-2" style="display: block">
    <div class="row" style="align-items: center; padding: 5px">
        <div class="col-xs-10 col-sm-10 col-md-10">
            <h3 class="modal-title" style="margin: 0px !important">
                <img src="/assets/images/patient_profile/transfer_no_corruption_icon_226109 1.svg"
                    style="border-radius: 4px; width: 28px" />
                <span class="h3 font-thin" style="
                        color: #58666e;
                        font-size: 22px;
                        vertical-align: bottom;
                        margin: 10px;
                    ">
                    Confirmation</span>
            </h3>
        </div>
        <div class="col-xs-2 col-sm-2 col-md-2">
            <button style="
                    border: none;
                    outline: none;
                    float: right;
                    background: transparent;
                " (click)="closeModal()">
                <img src="/assets/images/close.svg" style="border-radius: 4px; width: 28px" />
            </button>
        </div>
    </div>
</div>

<div class="modal-body">
    <div class="row header">
        <div>
            Are you sure you want to override the existing values with the new
            values?
            <b>This action cannot be undone.</b>
        </div>
    </div>

    <div class="table-responsive">
        <table class="table table-bordered table-striped mb-0">
            <thead class="thead-light">
                <tr>
                    <th>Label(s)</th>
                    <th style="width: 400px">Existing Values</th>
                    <th style="width: 420px">New Values</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>First Name</td>
                    <td>{{ data.existingValues.firstName }}</td>
                    <td>
                        <input type="text" class="form-control" [(ngModel)]="data.newValues.firstName"
                        (keypress)="keyPressAlphaNumeric($event)"
                        disallowSpaces />
                    </td>
                </tr>
                <tr>
                    <td>Middle Name</td>
                    <td>{{ data.existingValues.middleName }}</td>
                    <td>
                        <input type="text" class="form-control" [(ngModel)]="data.newValues.middleName " 
                        (keypress)="keyPressAlphaNumeric($event)"
                        disallowSpaces />
                    </td>
                </tr>
                <tr>
                    <td>Last Name</td>
                    <td>{{ data.existingValues.lastName }}</td>
                    <td>
                        <input type="text" class="form-control" [(ngModel)]="data.newValues.lastName"
                        (keypress)="keyPressAlphaNumeric($event)"
                        disallowSpaces
                         />
                    </td>
                </tr>
                <tr>
                    <td>Date of Birth</td>
                    <td>{{ data.existingValues.dateOfBirth }}</td>
                    <td>
                        <div class=" year" >
                            <div
                                class="input-group col-xs-12"
                                style="display: flex; width: 100%"
                            >
                                <mat-form-field appearance="fill">
                                    <input
                                        type="text"
                                        class="autocomplete-input"
                                        placeholder="Month"
                                        matInput
                                        [matAutocomplete]="month"
                                        style="
                                            caret-color: transparent;
                                            border: none;
                                            height: unset;
                                        "
                                        [(ngModel)]="dateOfBirthObject.dobMonth"
                                        onkeydown="return false;"
                                        (ngModelChange)="dateOfBirthObject.dobDay = null"
                                    />
                                    <i class="fa fa-caret-down align-arrow-right"></i>
                                    <mat-autocomplete
                                        #month="matAutocomplete"
                                        class="min-width-unset"
                                        [displayWith]="monthName.bind(this)"
                                    >
                                        <mat-option
                                            *ngFor="let item of months"
                                            [value]="item.id"
                                            style="font-size: 13px"
                                            (click)="setDays()"
                                        >
                                            {{ item.displayName }}
                                        </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>
                                <mat-form-field appearance="fill">
                                    <input
                                        type="text"
                                        placeholder="Day"
                                        matInput
                                        [matAutocomplete]="day"
                                        style="
                                            caret-color: transparent;
                                            border: none;
                                            height: unset;
                                        "
                                        [(ngModel)]="dateOfBirthObject.dobDay"
                                        onkeydown="return false;"
                                    />
                                    <i class="fa fa-caret-down align-arrow-right"></i>
                                    <mat-autocomplete
                                        #day="matAutocomplete"
                                        class="min-width-unset"
                                    >
                                        <mat-option
                                            *ngFor="let day of days"
                                            [value]="day"
                                            style="font-size: 13px"
                                        >
                                            {{ day }}
                                        </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>
                                <input
                                    style="width: 30%; font-size: 14px"
                                    id="year"
                                    type="text"
                                    tabindex="1"
                                    maxlength="4"
                                    class="form-control virtual-care text-center"
                                    placeholder="Year"
                                    [(ngModel)]="dateOfBirthObject.dobYear"
                                    (keypress)="checkNumber($event)"
                                />
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>Cell Phone</td>
                    <td>{{ data.existingValues.cellPhone }}</td>
                    <td>
                        <input type="text" class="form-control" [(ngModel)]="data.newValues.patientPhoneNumber"
                        (keyup)="formatNumber()"
                        (paste)="onPaste($event)"
                        (keypress)="checkNumber($event)"
                         maxlength="15"
                        />
                    </td>
                </tr>
                <tr>
                    <td>Home Phone</td>
                    <td>{{ data.existingValues.homePhone }}</td>
                    <td>
                        <input type="text" class="form-control" [(ngModel)]="data.newValues.patientHomePhoneNumber"
                        (keyup)="formatNumber()"
                        (paste)="onPaste($event)"
                        (keypress)="checkNumber($event)"
                         maxlength="15" />
                    </td>
                </tr>
                <tr>
                    <td>Email Address</td>
                    <td>
                        {{
                        data.existingValues?.emailAddresses[0]
                        ? data.existingValues?.emailAddresses[0]?.email
                        : ''
                        }}
                    </td>
                    <td>
                        <input type="text" class="form-control" [(ngModel)]="data.newValues.patientEmail" disallowSpaces />
                    </td>
                </tr>
                <tr>
                    <td>Street</td>
                    <td>{{ data.existingValues?.address?.addressLine1 }}</td>
                    <td>
                        <input type="text" class="form-control" [(ngModel)]="data.newValues.addressLine1" />
                    </td>
                </tr>
                <tr>
                    <td>City</td>
                    <td>{{ data.existingValues?.address?.city }}</td>
                    <td>
                        <input type="text" class="form-control" [(ngModel)]="data.newValues.city" />
                    </td>
                </tr>
                <tr>
                    <td>State</td>
                    <td>
                        {{ data.existingValues?.address?.stateOrProvinceCode }}
                    </td>
                    <td>
                        <ng-select
                [appendTo]="'body'"
                [clearable]="
                data.newValues.stateOrProvinceCode !== '' &&
                data.newValues.stateOrProvinceCode != null
                "
                [(ngModel)]="data.newValues.stateOrProvinceCode"
            >
                <ng-option
                    *ngFor="let state of data.stateList"
                    [value]="state.value"
                >
                    {{ state.valueShortDescription }}
                </ng-option>
            </ng-select>
                    </td>
                </tr>
                <tr>
                    <td>Zip</td>
                    <td>{{ data.existingValues?.address?.postalCode }}</td>
                    <td>
                        <input type="text" class="form-control" [(ngModel)]="data.newValues.postalCode" />
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
<div class="modal-footer">
    <div style="margin-left: auto">
      
    <button style="
                padding: 6px 30px;
                margin-right: 10px;
                border: 1px solid #dedede;
                font-size: inherit;
            " class="btn btn-default" (click)="closeModal()">
        Cancel
    </button>
    <button (click)="confirmationUpdate()"  class="btn btn-primary"  style="
    border: none;
    background: #1fbd75;
    color: white;
" >
   Update
</button>
</div>
</div>